import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// React 19 hoists Helmet metadata but does not adopt static head placeholders.
// Keep those placeholders in the server HTML, then hand ownership to React.
document.head.querySelectorAll('[data-rh="true"]').forEach(tag => tag.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
